import 'react-native-gesture-handler';
import { NavigationContainer } from '@react-navigation/native';
// import { useFonts } from 'expo-font';
import { GlobalProvider } from './src/context/GlobalProvider';
import DrawerNavigator from './src/navigations/DrawerNavigator';
import { Platform } from 'react-native';
import {  useFonts, Poppins_400Regular, Poppins_700Bold } from '@expo-google-fonts/poppins';

export const injectWebCss = () => {
	if ( Platform.OS === 'web' ) {
    const style = document.createElement('style');
    style.textContent = `textarea, select, input, button { outline: none !important; }`;
    document.head.append(style);
  }
}
injectWebCss()

export default function App () {
  const [loaded] = useFonts({
    Poppins: Poppins_400Regular,
    PoppinsBold: Poppins_700Bold,
  });

  if (!loaded) {
    return null;
  }

  return (
    <GlobalProvider>
      <NavigationContainer>
        <DrawerNavigator />
      </NavigationContainer>
    </GlobalProvider>
  );
}
